module.exports = __webpack_public_path__ + "img/Noctiluca-4.12d9f682.png";